const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = {
    dai: {
        id: 'dai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'DAI',
        decimals: 1e18,
        address: '0xc234A67a4F840E61adE794be47de455361b52413',
    },
    usdc: {
        id: 'usdc',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDC',
        decimals: 1e6,
        address: '0x8f552a71EFE5eeFc207Bf75485b356A0b3f01eC9',
    },
    usdt: {
        id: 'usdt',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDT',
        decimals: 1e6,
        address: '0x8e70cD5B4Ff3f62659049e74b6649c6603A0E594',
    },
    wglmr: {
        id: 'wglmr',
        type: REFERENCE_ASSETS.WGLMR,
        symbol: 'wGLMR',
        decimals: 1e18,
        address: '0xAcc15dC74880C9944775448304B263D191c6077F',
    },
    ldo: {
        id: 'ldo',
        type: REFERENCE_ASSETS.LDO,
        coingeckoId: 'lido-dao',
        symbol: 'LDO',
        decimals: 1e18,
        address: '0x9fda7ceec4c18008096c2fe2b85f05dc300f94d0',
    },
};
